module.exports = __webpack_public_path__ + "img/AUTO_PHOTO_NON.ebf89cd1.svg";